var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5258 32.3844C15.117 33.1193 13.5608 31.6863 14.2069 30.25L17.4731 23.0001L14.2069 15.7517C13.5592 14.3139 15.117 12.8808 16.5258 13.6157L31.6911 21.5383C31.9605 21.6791 32.186 21.8896 32.3432 22.1473C32.5004 22.405 32.5835 22.7001 32.5835 23.0009C32.5835 23.3017 32.5004 23.5967 32.3432 23.8544C32.186 24.1121 31.9605 24.3227 31.6911 24.4635L16.5258 32.3844Z",
    fill: "#6446C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.8c97b3b8482483592ae9abfeb3c6f0e1.svg";
export { ForwardRef as ReactComponent };